import React, {useContext} from 'react';
import Hls from 'hls.js'
import {makeStyles, Modal} from '@material-ui/core';
import 'pure-react-carousel/dist/react-carousel.es.css';
import './Tutorial.css'
import {AppContext} from "../AppContext";

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

interface VideoOverlay {
    stream: MuxStreamInfo
    streamUserId: number
    streamModal: boolean
}

interface MuxStreamInfo {
    id: string,
    playback_id: string
}

export default function VideoBroadcastOverlayModalBox(props: { videoOverlay: VideoOverlay | null }) {
    const useStyles = makeStyles((theme) => ({
        paper: {
            position: 'absolute',
            backgroundColor: theme.palette.background.paper,
            border: '2px solid #000',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
        },
    }));
    const classes = useStyles();

    const appContext = useContext(AppContext)
    const userId = (appContext.currentUser as any).id

    const muxPlaybackId = props.videoOverlay?.stream.playback_id

    let smallView = window.innerWidth - 150 < 1280;
    const videoWidth = smallView ? 845 : 1280
    const videoHeight = smallView ? 475 : 720

    // const embedUrl = youtubeVideoUrl !== null ? `https://www.youtube.com/embed/${youtubeVideoUrl}?controls=0` : null
    const playVideo = props.videoOverlay !== null && props.videoOverlay.streamModal && userId !== props.videoOverlay.streamUserId

    if(muxPlaybackId !== null && playVideo){
        setTimeout(() => {
            const url = "https://stream.mux.com/"+muxPlaybackId+".m3u8";
            const video = document.getElementById("main_video");

            if(video && video instanceof HTMLMediaElement) {
                // If HLS.js is supported on this platform
                if (Hls.isSupported()) {
                    const hls = new Hls();
                    hls.loadSource(url);
                    hls.attachMedia(video);
                    hls.on(Hls.Events.MANIFEST_PARSED, () => {
                        video.play();
                    });

                    // If the player can support HLS natively
                } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
                    video.src = url;
                    video.addEventListener('loadedmetadata', () => {
                        video.play();
                    });
                }
            }
        }, 500)
    }

    return (
        <Modal
            open={playVideo}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
        >
            <div style={getModalStyle()} className={classes.paper}>
                <video
                    width={videoWidth}
                    height={videoHeight}
                    id="main_video" autoPlay={true} controls></video>
            </div>
        </Modal>

    );
}

